import { inject } from "@angular/core";
import { CanActivateFn, CanActivateChildFn, Router } from "@angular/router";
import { map, of } from "rxjs";
import { SubscriptionService } from "shared/services/subscription.service";
import { settings } from "environments/environment";

/**
 * Guard sprawdzający czy subskrypcja użytkownika jest aktywna.
 * Jeśli subskrypcja wygasła - przekierowuje na stronę /konto/subskrypcje
 * 
 * WAŻNE: Guard czeka na załadowanie danych subskrypcji przed podjęciem decyzji,
 * dzięki czemu nie przekieruje użytkownika podczas inicjalizacji aplikacji.
 * 
 * Gdy flaga settings.enableSubscriptions jest wyłączona, guard przepuszcza wszystkich.
 */
export const SubscriptionActiveGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  // Gdy subskrypcje są wyłączone, przepuść wszystkich
  if (!settings.enableSubscriptions) {
    return of(true);
  }

  const router: Router = inject(Router);
  const subscriptionService: SubscriptionService = inject(SubscriptionService);

  // Czekamy na załadowanie danych subskrypcji
  return subscriptionService.getSubscriptionWhenLoaded().pipe(
    map((subscription) => {
      // Brak subskrypcji = wygasła lub nowy użytkownik
      if (!subscription) {
        router.navigate(['/konto/subskrypcje'], { 
          queryParams: { expired: 'true' } 
        });
        return false;
      }

      // Sprawdź czy subskrypcja jest aktywna
      const validUntil = subscription.validUntil 
        ? new Date(subscription.validUntil as unknown as string) 
        : null;
      
      const isActive = validUntil && validUntil > new Date();

      if (!isActive) {
        router.navigate(['/konto/subskrypcje'], { 
          queryParams: { expired: 'true' } 
        });
        return false;
      }

      return true;
    })
  );
};
